import eq from 'lodash/eq'

import { EventBus } from '@/EventBus.js'

const WIDGETS = 6

// @vue/component
export default {
  data: () => ({
    eventBus: EventBus,
    isDisabled: false,
    
    // Amount of widgets loaded
    loaded: 0
  }),

  mounted () {
    this.eventBus.$on('widget-loaded', () => this.loaded++)
    this.eventBus.$on('filter-selected', () => this.setIsDisabled(true))
  },

  watch: {
    loaded () {
      if (eq(this.loaded, WIDGETS)) {
        this.setIsDisabled(false)
        this.setLoaded(0)
      }
    }
  },

  methods: {
    emitHandler (event) {
      this.$emit('change', event)
      this.eventBus.$emit('filter-selected')
    },

    setIsDisabled (isDisabled) {
      this.isDisabled = isDisabled
    },

    setLoaded (loaded) {
      this.loaded = loaded
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/dashboard/filters/mixins/FilterMixin.js